export default function(cue, player, doneEditingCallback) {
  var self = this;
  var _doneCallback = doneEditingCallback;
  var _cue = cue;
  var _player = player;
  var _variant_counter = 0;
  var _max_variant_count = 3;

  self.id = ko.observable(_cue.id || '');
  self.dom_id = ko.observable('q-' + (self.id() || 'new-' + _.random(100)));
  self.field_definition = ko.observableArray();
  self._type = ko.observable('MultipleChoiceField');
  self.question_time = ko.observable(_cue.cue_start_time).extend(
    {
      required: true,
      min: {params: 0.0, message: Kadenze.I18n.t('session.media.validation_error.greater_than_zero')},
      max: {params: player.duration(), message: Kadenze.I18n.t('session.media.validation_error.less_than_duration')}
    });

  self.formattedQuestionTime = ko.pureComputed(
    {
      read: function () {
        var seconds = parseFloat(self.question_time());

        var timeStr = 'n/a';

        if (!isNaN(seconds)) {
          var t = new Date(1970, 0, 1);
          t.setSeconds(Math.floor(seconds));
          timeStr = t.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1');
          //add fractional seconds
          var frac = Math.round10(seconds % 1, -3);
          if (frac > 0)
            timeStr += Math.round10(seconds % 1, -3).toString().substring(1);
        }

        return timeStr;
      },
      write: function (value) {
        var secs = null;
        if (!isNaN(parseInt(value)) || value.match(/\d{2}:\d{2}:\d{2}(\.\d{1,3})?/)) {
          var timeArray = value.split(':');
          secs = 0.0;

          if (timeArray.length <= 3) {
            $.each(timeArray, function (ix, t) {
              secs += Math.pow(60.0, timeArray.length - ix - 1) * parseFloat(t);
            });
          }
        }

        self.question_time(secs);
        //var errors = ko.validation.group(self.question_time);
        //errors.showAllMessages();
        self.formattedQuestionTime.notifySubscribers();
      }
    });

  self.setQuestionTime = function () {
    self.question_time(Math.round10(_player.currentTime(), -3).toString());
    //_cue.cue_start_time(self.question_time());
    //_cue.cue_start_time.notifyAllSubscribers();
  };

  self.done = function () {
    var errors = self.validate(true);

    if (errors.length === 0) {
      if (!_cue.id) //a new cue
      {
        _cue.cued = {
          _type: self._type(),
          name: null,
          definition: null
        };
      }

      _cue.cued.name = s.stripTags(self.name());
      _cue.cue_start_time = self.question_time();
      _cue.cue_end_time = '-1.0';
      _cue.cued.definition = ko.toJS(self.field_definition);

      _doneCallback(_cue, false);
    }
  };

  self.cancel = function () {
    _doneCallback(null, true);
  };

  self.validate = function (deep) {
    self.client_errors = ko.validation.group([self.question_time, self.field_definition()], {deep: deep});
    self.client_errors.showAllMessages();
    return self.client_errors();
  };

  self.addFieldDefinition = function (fd, active) {

    var base_fd = {
      question: ko.observable(Kadenze.Util.objFromString(fd, 'question', '')),
      explaination: ko.observable(Kadenze.Util.objFromString(fd, 'explaination', '')),
      attachments: ko.observableArray(Kadenze.Util.objFromString(fd, 'attachments', [])),
      attachment_ids: ko.observableArray(Kadenze.Util.objFromString(fd, 'attachment_ids', [])),
      _type: ko.observable(Kadenze.Util.objFromString(fd, '_type', '')),
      active: ko.observable(active || false)
    };

    var options = Kadenze.Util.objFromString(fd, 'options', null);
    var ko_options = [];
    if (options) {
      $.each(options, function (ix, option) {
        ko_options.push({
          answer: ko.observable(option.answer),
          selected: ko.observable(option.selected)
        });
      });
    }
    else {
      for (var i = 0; i < 4; i++) {
        ko_options.push({answer: ko.observable(''), selected: ko.observable(false)});
      }
    }

    var fd_new = $.extend({}, base_fd, {
      dom_id: ko.observable(self.dom_id() + '-t-' + _variant_counter++),
      options: ko.observableArray(ko_options),
      selected_option: ko.observable(self.getSelectedOption(ko_options)).extend({required: {message: Kadenze.I18n.t('form_builder.multiple_choice_option_validation')}})
    });

    self.field_definition.push(fd_new);
  };

  self.getSelectedOption = function (options) {
    var selected_option = null;
    $.each(options, function (index, option) {
      if (option.selected() === 'true' || option.selected() === true) {
        selected_option = option;
      }
    });
    return selected_option;
  };

  self.name = ko.computed(function () {
    //var name = "Video question at " + _cue.cue_start_time.toString() + " seconds" + (self.field_definition()[0] ? ": " + self.field_definition()[0].question() : "");
    var name = self.field_definition()[0] ? self.field_definition()[0].question() : 'Video question at ' + _cue.cue_start_time.toString() + ' seconds.';
    return name.trimToLength(250).toString();
  });

  self.initTabUI = function (element, item) {
    var $tab = $(element);

    var $dropzoneArea = $('#dz-' + $tab.attr('id'));
    self.addDropZoneToTab($dropzoneArea, item);
  };

  self.initOptionsUI = function (element, item) {
    var $option = $(element);
    var $label = $option.find('label');

    if (JSON.parse(item.selected())) {
      $label.addClass('selected');
      //$label.css('background-position', '0px -32px');
    }
  };

  self.selectOption = function (option, parent) {
    ko.utils.arrayForEach(parent.options(), function (option) {
      option.selected(false);
    });
    option.selected(true);
    parent.selected_option(option);
    return true;
  };

  self.addMultipleChoiceOption = function (item, event) {
    item.options.push({answer: ko.observable(''), selected: ko.observable(false)});
  };

  self.deleteMultipleChoiceOption = function (item, event) {
    ko.utils.arrayForEach(self.field_definition(), function (fd) {
      fd.options.remove(function (option) {
        return option === item;
      });
    });
  };

  self.addTab = function () {
    if (_variant_counter >= _max_variant_count) {
      return;
    }

    self.hideAllTabs();
    self.addFieldDefinition({_type: self._type()}, true);
  };

  self.removeTab = function () {
    self.field_definition.remove(function (field) {
      return field.active() === true;
    });

    _variant_counter--;

    self.hideAllTabs();
    self.showLastTab();
  };

  self.hideAllTabs = function () {
    ko.utils.arrayForEach(self.field_definition(), function (field) {
      field.active(false); //'active' is an observable controlling visibility
    });
  };

  self.showTab = function (item, event) {
    self.hideAllTabs();
    item.active(true);
  };

  self.showLastTab = function () {
    self.field_definition()[self.field_definition().length - 1].active(true);
  };

  self.addDropZoneToTab = function ($dropArea, item) {
    var $question = $('#' + item.dom_id());
    //var fileTypes = '.jpg, .png';
    var message = JST['templates/dropzone-standard-message']({
      title: 'Drop question media file here (audio or image)',
      //fileTypes: fileTypes
      optional: ''
    }
    );
    var uploadURL = $dropArea.parent().attr('action');

    var opts = {
      autoProcessQueue: true,
      paramName: 'attachment[file]',
      previewsContainer: '#' + item.dom_id() + ' .dz-media-preview',
      previewTemplate: Kadenze.I18n.tt(JST['templates/media-question-dropzone-preview']()),
      acceptedFiles: '.jpeg, .jpg, .png, .svg, .mp3, audio/wav, audio/aac'
    };

    var callbacks = {
      sending: function (file, xhr, formData) {
        Kadenze.UIUtil.showLoadingIndicator($question);
      },
      uploadprogress: function (file, progress, bytesSent) {
        var uploaded = file.size * (progress / 100);
        uploaded = (uploaded < 1000000 ) ? (Math.round(uploaded / 100) / 10) + ' KB' : (Math.round(uploaded / 100000) / 10) + ' MB';
        var total = (file.size < 1000000 ) ? (Math.round(file.size / 100) / 10) + ' KB' : (Math.round(file.size / 100000) / 10) + ' MB';
        $('.dz-file-size', file.previewTemplate).html('&nbsp;' + uploaded + ' of ' + total);
      },
      success: function (file, response) {
        if (response.files[0]) {

          //skip mock files
          if (file.upload.bytesSent > 0) {
            item.attachment_ids.push(response.files[0].id);
            item.attachment_ids(Kadenze.Util.cleanupArray(item.attachment_ids()));

            var att = response.files[0];
            att.meta = {type: 'image'};
            item.attachments.push(att);
          }

          $(file.previewTemplate).attr('id', 'attachment_' + response.files[0].id);
          $(file.previewTemplate).attr('value', response.files[0].id);

          var total = (file.size < 1000000 ) ? (Math.round(file.size / 100) / 10) + ' KB' : (Math.round(file.size / 100000) / 10) + ' MB';
          $('.dz-file-size', file.previewTemplate).html('&nbsp;' + total);
        }
      },
      error: function (file, errorMessage) {
        Kadenze.UIUtil.showNotice($('#' + item.dom_id()), {message: errorMessage}, 1000);
      },
      complete: function (file) {
        Kadenze.UIUtil.hideLoadingIndicator($question);
      },
      removedfile: function (file) {
        var file_id = file.id;
        item.attachment_ids.remove(function (attachment_id) {
          return attachment_id === file_id.toString();
        });
      },
      sortableUpdate: function (e, ui) {
        var orderd_ids = $(opts.previewsContainer).sortable('toArray', {attribute: 'value'});
        orderd_ids = orderd_ids.map(function (x) {
          return parseInt(x);
        });
        item.attachment_ids(orderd_ids);

      }
    };

    var mediaDZ = Kadenze.MediaDropZone($dropArea, $(message), opts, callbacks, true);

    $.each(item.attachments(), function(index, attachment) {
      var mockFile = { id: attachment.id, name: attachment.name, path: attachment.file.url, thumb: attachment.file.thumb.url, size: attachment.size, status: Dropzone.SUCCESS, type: attachment.meta.type };
      mediaDZ.addMockFile(mockFile);
      mediaDZ.options.maxFiles--;
    });
  };

  //constructor
  //populate with existing cue question if editing (vs. new)
  if (_cue.cued && _cue.cued.field_definition) {
    $.each(_cue.cued.field_definition, function (index, field_definition) {
      self.addFieldDefinition(ko.toJS(field_definition), index === 0);
    });
  }
  else {
    //add a blank question/field definition tab
    self.addTab();
  }

  console.log('session media question editor started');
}

